import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';
import iconBiomarker from "src/assets/images/admin-dashboard/biomarker-icon.png";
import iconTest from "src/assets/images/admin-dashboard/test-icon.png";
import iconCategory from "src/assets/images/admin-dashboard/category-icon.png";
import iconOrder from "src/assets/images/admin-dashboard/purchase-order.png";
import iconRevenue from "src/assets/images/admin-dashboard/revenue-icon.png";
import { CURRENCY } from 'src/lib/constans';

type IStatsKeys = "biomarkers" | "tests" | "packages" | "categories" | "totalOrder" | "totalRevenue";
const DiagnosticStates: React.FC = () => {
    const [statsLoader, setStatsLoader] = useState<boolean>(false);
    const [statsData, setStatsData] = useState<{ label: string; key: IStatsKeys; count: number; images: string }[]>([
        { label: "Total Biomarkers", key: "biomarkers", count: 0, images: iconBiomarker },
        { label: "Total Tests", key: "tests", count: 0, images: iconTest },
        { label: "Packages", key: "packages", count: 0, images: iconTest },
        { label: "Total Categories", key: "categories", count: 0, images: iconCategory },
        { label: "Total Orders", key: "totalOrder", count: 0, images: iconOrder },
        { label: "Total Revenue", key: "totalRevenue", count: 0, images: iconRevenue },
    ]);
    const fetchStats = async () => {
        setStatsLoader(true);
        const { res, err } = await httpRequest<{ data: { [keys in IStatsKeys]: number } }>({
            path: "/diagnostic-order/statistics",
        });
        if (res) {
            const updatedStatsData = statsData.map((item) => {
                return {
                    ...item,
                    count: res.data[item.key],
                };
            });
            setStatsData(updatedStatsData);
        } else {
            toast(err, { type: "error" });
        }
        setStatsLoader(false);
    };

    useEffect(() => {
        fetchStats();
    }, []);
    return (
        <div className='parent-box'>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
                {statsData.map(item => (
                    <div key={item.key} className="dashboard-sm-box">
                        <div className="dashboard-inner-box w-[80%] text-center">
                            <img className='admin-dashboard-img' src={item?.images} alt="biomarker-icon" />
                            <p className="font-Poppins-Medium whitespace-nowrap font-size-20px">
                                {item?.label || ""}
                            </p>
                            {statsLoader
                                ?
                                <CircularProgress size={20} className="theme-color-green" />
                                :
                                <p className="font-Poppins-SemiBold font-size-26px theme-color-green">
                                    {`${item.key === "totalRevenue" ? CURRENCY : ""}${item.count || "-"}`}
                                </p>
                            }
                        </div>
                    </div>
                ))
                }
            </div>
        </div>
    );
};

export default DiagnosticStates;